import { type MutableRefObject, useCallback } from 'react';

type SetRef = (node: HTMLElement | null) => void;

export const useCombinedDndRef = (
  storeRef: MutableRefObject<HTMLElement | null>,
  draggableSetRef: SetRef,
  dropTargetSetRef: SetRef,
): SetRef =>
  useCallback(
    (node: HTMLElement | null) => {
      storeRef.current = node;
      draggableSetRef(node);
      dropTargetSetRef(node);
    },
    [storeRef, draggableSetRef, dropTargetSetRef],
  );
